import React from "react";

import "../Chats.css";

const ChatConversation = () => {
    return (
        <div className="chat_conversation_container">
            <p className="chat_conversation_overlay">Selecione um participante para iniciar conversa.</p>
        </div>
    );
};

export default ChatConversation;